import { unref } from 'vue';
import ApiClient from '@/ApiClient';
import { queryOptions, useQueryClient } from '@tanstack/vue-query';

export const getRecognitionLedger = () => {
  return queryOptions({
    queryKey: ['recognition_ledger'],
    queryFn: async () => {
      return await ApiClient.getRecognitionLedger();
    },
  });
};

export const getRecognitionInvoices = () => {
  return queryOptions({
    queryKey: ['recognition_invoices'],
    queryFn: async () => {
      const result = await ApiClient.getRecognitionInvoices();
      return result.data;
    },
  });
};

export const createRecognitionInvoice = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async payload => {
      return await ApiClient.createRecognitionInvoice(payload);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['recognition_invoices'] });
      await queryClient.invalidateQueries({ queryKey: ['recognition_ledger'] });
    },
  };
};

export const deleteRecognitionInvoice = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async invoiceId => {
      return await ApiClient.deleteRecognitionInvoice(invoiceId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['recognition_invoices'] });
      await queryClient.invalidateQueries({ queryKey: ['recognition_ledger'] });
    },
  };
};

export const getRecognitionUnlinkedDeposits = (enabled = () => true) => {
  return queryOptions({
    enabled,
    queryKey: ['recognition_unlinked_deposits'],
    queryFn: async () => {
      const result = await ApiClient.getRecognitionUnlinkedDeposits();
      return result.data;
    },
  });
};

export const getRecognitionActivity = params => {
  return queryOptions({
    queryKey: ['recognition_activity', params],
    queryFn: async () => {
      const result = await ApiClient.getRecognitionActivity(unref(params));
      return result || [];
    },
  });
};

export const withdrawRecognitionGrant = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async ({ grantId, reason }) => {
      return await ApiClient.withdrawRecognitionGrant(grantId, reason);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['recognition_activity'] });
      await queryClient.invalidateQueries({ queryKey: ['recognition_ledger'] });
    },
  };
};

export const markRecognitionInvoiceComplete = () => {
  const queryClient = useQueryClient();

  return {
    mutationFn: async ({ invoiceId, depositIds }) => {
      return await ApiClient.markRecognitionInvoiceComplete(invoiceId, depositIds);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['recognition_invoices'] });
      await queryClient.invalidateQueries({ queryKey: ['recognition_ledger'] });
      await queryClient.invalidateQueries({ queryKey: ['recognition_unlinked_deposits'] });
    },
  };
};
